import cn from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

type IProps = {
  classname?: string;
  data: any;
};

const SafePromoHistoryTable: FC<IProps> = ({ classname, data }) => {
  const { t }: Translation = useTranslation();

  return (
    <div className={cn('safe_promo_history_table_wrapper', classname)}>
      {data?.length && data?.length > 0 ? (
        <div className="safe_promo_history_table">safe_user_history_table</div>
      ) : (
        <div className="safe_promo_history_table_empty">
          <span>{t('noHistoryYet')}</span>
        </div>
      )}
    </div>
  );
};

export default SafePromoHistoryTable;
